<template>
  <div class="mobile-news">
    <!-- 新闻分类 -->
    <div class="category-list">
      <div
        v-for="(item, index) in categories"
        :key="index"
        class="category-item"
        :class="{ active: currentCategory === item.id }"
        @click="handleCategoryChange(item.id)"
      >
        {{ item.title }}
      </div>
    </div>

    <!-- 新闻列表 -->
    <div class="news-list">
      <div
        v-for="(item, index) in newsList"
        :key="index"
        class="news-item"
        @click="goToDetail(item)"
      >
        <div class="news-image"  v-if="!selectedNews">
          <img :src="item.image" :alt="item.title">
          <div class="news-image-info">
            <div class="news-title">{{ item.title }}</div>
            <p class="news-body">
              <span class="news-desc" v-html="$formatContent(item.content, 29)"></span>
              <span class="show-more" @click="goToDetail(item)">查看更多</span>
            </p>
          </div>
        </div>
        <div class="news-info" v-else>
          <el-button type="text" icon="el-icon-arrow-left" @click="backToList" style="margin-bottom: 16px;">返回</el-button>
          <div class="title">{{ item.title }}</div>
          <div class="desc" v-html="item.content"></div>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more" v-if="hasMore" @click="loadMore">
      <span v-if="!loading">加载更多</span>
      <span v-else>加载中...</span>
    </div>
  </div>
</template>

<script>
import { articleList, articleClass } from '@/api/index'
export default {
  name: 'MobileNews',
  data() {
    return {
      categories: [],
      currentCategory: null,
      newsList: [],
      page: 1,
      pageSize: 10,
      hasMore: true,
      loading: false,
      selectedNews: null
    }
  },
  created() {
    this.getCategories()
    this.getNews()
  },
  methods: {
    getCategories() {
      articleClass({classify_id: 4}).then(res => {
        if (res.data) {
          this.categories = res.data.rows
          if (this.categories.length > 0) {
            this.currentCategory = this.categories[0].id
            this.getNews(this.currentCategory)
          }
        }
      })
    },
    getNews(id) {
      this.loading = true
      articleList({
        classify_id: id
      }).then(res => {
        this.loading = false
        if (res.data.rows) {
          this.newsList = res.data.rows.filter(item => item.status !== 0)
        } else {
          this.newsList = []
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleCategoryChange(categoryId) {
      this.currentCategory = categoryId
      this.page = 1
      this.newsList = []
      this.getNews(this.currentCategory)
    },
    loadMore() {
      if (this.loading) return
      this.page++
      this.getNews()
    },
    goToDetail(item) {
      this.selectedNews = item
    },
    backToList() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-news {
  padding: 15px;
}

.category-list {
  display: flex;
  overflow-x: auto;
  margin-bottom: 15px;
  padding-bottom: 10px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  .category-item {
    flex-shrink: 0;
    padding: 8px 15px;
    margin-right: 10px;
    background: #f5f5f5;
    border-radius: 20px;
    font-size: 14px;
    color: #666;
    white-space: nowrap;

    &.active {
      background: #2c9dcf;
      color: #fff;
    }
  }
}

.news-list {
  .news-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);

    .news-image {
      width: 100%;
      height: 140px;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;

      img {
        width: 120px;
        height: 100%;
        object-fit: cover;
        padding-right: 10px;
      }
      .news-title {
        font-weight: 500;
      }
      .news-desc {
        font-size: 13px;
        color: #777;
        line-height: 1.4;
        margin-top: 4px;
      }
      .show-more {
        font-size: 12px;
        color: #2c9dcf;
        margin-top: 4px;
        cursor: pointer;
      }
    }
    .news-info {
      margin-right: 15px;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
      }

      .desc {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
        margin-bottom: 15px;
      }
    }
  }
}

.load-more {
  text-align: center;
  padding: 15px 0;
  color: #666;
  font-size: 14px;
}
</style>
